<template>
	<div class="mt-70">
		<app-header></app-header>
        <v-container grid-list-xl pa-0>
            <V-layout row wrap justify-center align-center mb-0>
                <v-flex lg12 sm12 xs12 md12 class="text-xs-center">
                    <!-- <v-card flat class="mx-5"> -->
                                <div class="font-24">Financial Forecasts & Token Economics</div>
                                <div class="font-14 mt-2">Unaudited Projections Based on Company's Latest Financial Models</div>
                    <!-- </v-card> -->
                </v-flex>
                <v-flex xs12 mt-5 mb-5>
                    <v-container pa-0 grid-list-xl fluid>
                        <v-layout row wrap  class="text-xs-center">
                            <v-flex xs12 sm6 md12>
                                   <div class="font-16 primary--text">2018-21 IOB QUALIFIED RESERVE</div>
                                    <div class="mt-3">
                                        <v-img src="https://images.iob.community/SIP/material/website/ir/qr.png" contain height="400px">             
                                        </v-img>
                                    </div>
                            </v-flex>
                           <v-flex xs12 sm6 md12>
                                   <div class="font-16 primary--text">2018-21 IOB REVENUE PROJECTION</div>
                                    <div class="mt-3">
                                        <v-img src="https://images.iob.community/SIP/material/website/ir/pr.png" contain height="400px">             
                                        </v-img>
                                    </div>
                            </v-flex>
                            <v-flex xs12 sm6 md12>
                                   <div class="font-16 primary--text">2018-21 IOB NET REVENUE & NET INCOME</div>
                                    <div class="mt-3">
                                        <v-img src="https://images.iob.community/SIP/material/website/ir/nr.png" contain height="400px">             
                                        </v-img>
                                    </div>
                            </v-flex>
                            <v-flex xs12 sm6 md12>
                                   <div class="font-16 primary--text">2017-21 IOB TOKEN SOLD</div>
                                    <div class="mt-3">
                                        <v-img src="https://images.iob.community/SIP/material/website/ir/ts.png" contain height="400px">             
                                        </v-img>
                                    </div>
                            </v-flex>
                            <v-flex xs12 sm6 md12>
                                   <div class="font-16 primary--text">IOB TOTAL TOKENS</div>
                                    <div class="mt-3">
                                        <v-img src="https://images.iob.community/SIP/material/website/ir/tt.png" contain height="400px">             
                                        </v-img>
                                    </div>
                            </v-flex>
                            <v-flex xs12 sm6 md12>
                                   <div class="font-16 primary--text">2018-19 FUNDING</div>
                                    <div class="mt-3">
                                        <v-img src="https://images.iob.community/SIP/material/website/ir/funding.png" contain height="400px">             
                                        </v-img>
                                    </div>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap justify-center align-center mt-5>
                            <v-flex lg12 sm12 xs12 md12 class="text-xs-center">
                                <!-- <v-card flat class="mx-5"> -->
                                <div class="font-24"> IOB Token Address & Code</div>
                                <div class="font-14 mt-2">Please double check the token address on your wallet</div>
                                <!-- </v-card> -->
                            </v-flex>
                             <v-flex xs12 sm6 md12>
                                <v-card class="px-3 py-3">
                                    <v-list>
                                    <v-list-tile avatar>
                                        <v-list-tile-content>
                                        <v-list-tile-title>ERC20 CONTRACT ADDRESS</v-list-tile-title>
                                        <v-list-tile-sub-title>0x6130ff302f24267380753e52ECe48B852be3Dd38</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-list-tile avatar>
                                        <v-list-tile-content>
                                        <v-list-tile-title>ETHERSCAN CONTRACT ADDRESS</v-list-tile-title>
                                        <v-list-tile-sub-title><a href="https://etherscan.io/address/0x6130ff302f24267380753e52ece48b852be3dd38#" >https://etherscan.io/address/0x6130ff302f24267380753e52ece48b852be3dd38</a></v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-list-tile avatar>
                                        <v-list-tile-content>
                                        <v-list-tile-title>GITHUB CONTRACT REPOSITORIES</v-list-tile-title>
                                        <v-list-tile-sub-title><a href="https://github.com/IOBteam?tab=repositories" >https://github.com/IOBteam?tab=repositories</a></v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    </v-list>                              
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm6 md12 mt-5 class="text-lg-right">
                                <div>
                                    <a :href="domainName">
                                        <v-icon color="grey" size="20" >arrow_back</v-icon>	
                                    </a>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
            </V-layout>
        </v-container>

	</div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import config from '../../config.js'
    export default {
        data(){
            return{
                domainName: config.ip
            }
        },
        created(){
            
        },
        mounted(){
            
        },
        watch:{
            
        },
        methods: {
            


        },
    }
</script>


// WEBPACK FOOTER //
// Investorrelations.vue?4ead8d0e